import { render, staticRenderFns } from "./user_info.vue?vue&type=template&id=5027c8c9&"
import script from "./user_info.vue?vue&type=script&lang=coffee&"
export * from "./user_info.vue?vue&type=script&lang=coffee&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports